/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.59"
        height="91.93"
        viewBox="0 0 95.59 91.93"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M72.87 0a8.21 8.21 0 0 1 7.72 6.16 6.45 6.45 0 0 1 .25 1.61v71.91a1.25 1.25 0 0 1-2.49.13V8.12a4.45 4.45 0 0 0-.16-1.27A5.74 5.74 0 0 0 73.1 2.5H9.58A1.25 1.25 0 0 1 9.5.01h63.42Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M86.75 91.93H24.59a8.13 8.13 0 0 1-8.09-7.88V47.9H1.25a1.25 1.25 0 0 1-1.24-1.13V9.58A9.29 9.29 0 0 1 9.5 0a9.06 9.06 0 0 1 9.49 9.28v74.53a5.61 5.61 0 0 0 5.4 5.61h2c3.46 0 5.26-1.64 6-4.56a13.12 13.12 0 0 0 .27-4.45v-.53a1.27 1.27 0 0 1 1.11-1.46h60.48a1.25 1.25 0 0 1 1.23 1V80.12a15.72 15.72 0 0 1-.33 5.31c-1 3.87-3.6 6.33-8.1 6.44Zm6.3-11H35.2v.1a15.16 15.16 0 0 1-.29 4l-.1.44a9.08 9.08 0 0 1-1.95 3.87l-.07.08h54c3.36 0 5.16-1.55 5.93-4.31l.07-.25a12.61 12.61 0 0 0 .32-3.57ZM9.74 2.5H9.5a6.79 6.79 0 0 0-7 6.82V45.4h14V9.58c0-4.37-2.9-7.02-6.76-7.08Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M31.61 12.06v2.14l-.34.07-.33.06a5.15 5.15 0 0 0-3.87 3.17 6.38 6.38 0 0 0-.45 2.93 5 5 0 0 0 2.69 4.28 20.54 20.54 0 0 0 2.25 1c.94.4 1.9.76 2.84 1.16a1.72 1.72 0 0 1 1.1 1.84 1.87 1.87 0 0 1-1.5 1.88 5.36 5.36 0 0 1-1.19.13 3 3 0 0 1-3-2.21c-.09-.26-.15-.53-.23-.82l-3.59.92a7.44 7.44 0 0 0 1.73 3.56 6 6 0 0 0 3.94 1.81v2.78h2.32v-2.75c.47-.1.92-.17 1.36-.28a5.35 5.35 0 0 0 3.78-3.07 6.17 6.17 0 0 0 .38-3.74 4.92 4.92 0 0 0-2.51-3.57 29.91 29.91 0 0 0-3.43-1.5c-.71-.28-1.39-.6-2.07-.93a1.51 1.51 0 0 1-.77-.94 2.09 2.09 0 0 1 1.46-2.64 2.43 2.43 0 0 1 2.4.63 4.41 4.41 0 0 1 1 1.47c.08.18.15.36.23.55l3.22-1.33a6.57 6.57 0 0 0-1.18-2.42 5.62 5.62 0 0 0-3.91-2v-2.18Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M70.15 15.27a1.002 1.002 0 0 1 .12 2H45.76a1.002 1.002 0 0 1-.12-2h24.51ZM64.86 23.09a1.002 1.002 0 0 1 .12 2H45.76a1.002 1.002 0 0 1-.12-2h19.22ZM61.14 30.91a1.002 1.002 0 0 1 .11 2H45.76a1.002 1.002 0 0 1-.12-2h15.5ZM70.36 66.5a1.002 1.002 0 0 1 .12 2H28.01a1.002 1.002 0 0 1-.12-2h42.47Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M32.88 53.9a1 1 0 0 1 1 .88V67.5a1.002 1.002 0 0 1-2 .12V54.9a1 1 0 0 1 1-1ZM41.03 45.4a1 1 0 0 1 1 .88v19.73a1.002 1.002 0 0 1-2 .12V46.4a1 1 0 0 1 1-1ZM49.18 51.89a1 1 0 0 1 1 .88v13.24a1.002 1.002 0 0 1-2 .12V52.89a1 1 0 0 1 1-1ZM57.33 55.21a1 1 0 0 1 1 .88v9.92a1.002 1.002 0 0 1-2 .12v-9.92a1 1 0 0 1 1-1ZM65.5 42.78a1 1 0 0 1 1 .88v22.35a1.002 1.002 0 0 1-2 .12V43.78a1 1 0 0 1 1-1Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'PaperWithDollarSignAndBarChartIcon';

export default Icon;
